import { IErrorResponse } from 'typeScript/interfaces/IErrorMessage'
import { ApiResponse, IKycStatus, IKycUrl } from 'typeScript/interfaces/IKyc'

export const isErrorResponse = (
  status:
    | IKycStatus
    | IKycUrl
    | IErrorResponse
    | ApiResponse<IKycStatus>
    | ApiResponse<IKycUrl>
    | ApiResponse<IErrorResponse>
): status is IErrorResponse => {
  // Check if the error message exists for IErrorResponse
  return (status as IErrorResponse).message !== undefined
}

export const mapKycEnumValue = <T extends Record<string, string>>(
  enumObject: T,
  key: string
): T[keyof T] => {
  return enumObject[key as keyof T] ?? undefined ?? key
}
